import React, { Component } from 'react';
import style from './style.css';
import CSSModule from 'react-css-modules';

const Footer = () => {
    return(
        <div styleName="container">
            <p>© 2017 武林文創股份有限公司</p>
        </div>
    );
}


export default CSSModule(Footer,style);



/** WEBPACK FOOTER **
 ** ./src/container/footer/index.js
 **/